module.exports = __webpack_public_path__ + "static/img/star4-yellow.01a27b63.png";